import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, Validators} from '@angular/forms';
import {ReportService} from '../../../../services/report.service';
import {Router} from '@angular/router';
import {ClientService} from '../../../../services/client.service';
import {Err} from '../../../../err';
import EMAIL_REGEX from '../../../../validators/regex/email.regex';

@Component({
  selector: 'app-client-invite-dialog',
  templateUrl: './client-invite-dialog.component.html',
})
export class ClientInviteDialogComponent implements OnInit {

  submitted = false;
  isLoading = false;
  form;
  clientId;
  onInvite = new EventEmitter<void>();
  error = '';

  constructor(public dialogRef: MatDialogRef<ClientInviteDialogComponent>,
              private builder: FormBuilder,
              private router: Router,
              private reportService: ReportService,
              private clientService: ClientService,
              @Inject(MAT_DIALOG_DATA) public data) {
  }

  ngOnInit(): void {
    this.form = this.getCleanForm();
    this.clientId = this.data.clientId;
  }

  private getCleanForm() {
    return this.builder.group({'email': ['', [Validators.required, Validators.pattern(EMAIL_REGEX)]]});
  }

  cancel(): void {
    this.dialogRef.close();
  }

  invite() {
    this.submitted = true;
    if (this.form.invalid || this.isLoading) { return; }
    this.isLoading = true;
    this.clientService.invite(this.f.valueOf('email').email.value, this.clientId).subscribe(() => {
      this.isLoading = false;
      this.onInvite.emit();
      this.cancel();
    }, (err) => {
      this.error = Err[err.error.message];
      this.isLoading = false;
    });
  }

  get f() {
    return this.form.controls;
  }

}
